import { Paper } from '@mui/material';
import React from 'react';
import { themeColors } from '../JuvareTheme';
import { gradients } from './colors';
/**
 * A wrapper component that renders a MUI Paper element with a specified gradient background and white text.
 *
 * @param {ColorPaperProps} props - The props for the ColorPaper component.
 * @param {keyof typeof gradients} props.gradient - The gradient key used to style the background.
 * @param {string} [props.className] - Optional class name to apply to the component.
 * @param {SxProps<Theme>} [props.sx] - Optional MUI `sx` prop to apply custom styles.
 * @param {React.ReactNode} props.children - The content to render inside the Paper.
 * @returns {JSX.Element} The rendered Paper component with gradient background and white text.
 */
export const ColorPaper = (props) => {
    const { gradient, className, sx, children } = props;
    return (React.createElement(Paper, { elevation: 0, sx: [
            Object.assign(Object.assign({}, gradients[gradient]), { color: themeColors.decorative.white, borderRadius: 0 }),
            ...(Array.isArray(sx) ? sx : [sx]),
        ], className: className, "data-test": 'color-paper', "data-color": gradient }, children));
};
